















import { defineComponent, PropType } from "@vue/composition-api";
import InputFileMixin from "@/mixins/InputFileMixin";
import useFileSize from "@/hooks/useCheckFileSize";
import { getNameMimeType } from "@/lib/fileHelpers";
import config from "@/config";
import { AttachmentFile } from "@/types";

export default defineComponent({
  name: "BaseInputFile",
  mixins: [InputFileMixin(config.fileTypes)],
  props: {
    multiple: {
      type: Boolean,
      default: false,
    },
    files: {
      type: [Object, Array] as PropType<AttachmentFile[] | FileList | null>,
      default: null,
    },
    showUploader: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { checkFilesSize } = useFileSize();
    return { checkFilesSize };
  },
  methods: {
    showFileUpload() {
      const input = this.$refs.input;
      if (input instanceof HTMLInputElement) {
        input.value = "";
        input.click();
      }
    },
    selectFile(e: Event) {
      e.stopPropagation();
      const element = e.target as HTMLInputElement;
      let files = element.files
        ? Array.from(element.files).filter(f => {
            let type = getNameMimeType(f.name);
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            return !this.accept || (type && this.acceptTypes.includes(type));
          })
        : [];
      if (files.length > 0) {
        files = this.checkFilesSize(files);
        this.$emit("input", files);
        if (this.files === null) (this.$refs.input as HTMLInputElement).value = "";
      }
    },
  },
  watch: {
    clearInput(newValue: FileList | null) {
      if (newValue === null) (this.$refs.input as HTMLInputElement).value = "";
    },
    showUploaderWatcher(newValue: boolean | null) {
      if (newValue) this.showFileUpload();
    },
  },
});
